import { SocketTopics } from "../constants/enums";
import useSocketService from "../hooks/useSocketService";

export default (): ISocket => {
  const {
    socketClient,
    socketConnect,
    socketSubscribeToEvent,
    socketPublishToEvent,
    socketUnSubscribeToEvent,
    subscribeToEventSurvey,
    publishToEventServiceIdSurvey,
  } = useSocketService();

  const subscribeToEvent = (
    topic: SocketTopics,
    subscriptionPath: string,
    callback = () => {},
    componentUuid?: string,
  ) => {
    socketSubscribeToEvent(topic, subscriptionPath, callback, componentUuid);
  };

  const unSubscribeToEvent = (
    topic: SocketTopics,
    subscriptionPath: string,
    callback = () => {}
  ) => {
    socketUnSubscribeToEvent(topic, subscriptionPath, callback);
  };

  const publishToEvent = (
    topic: SocketTopics,
    subscriptionPath: string,
    payload: IPublishWrapRequest | IPublishRequest,
    callback = () => {}
  ) => {
    socketPublishToEvent(topic, subscriptionPath, payload, callback);
  };

  const subscribeToSurvey = (
    event: SocketTopics,
    topic: string,
    callback = () => {},
    componentUuid?: string,
  ) => {
    console.log('=-=-=-=-=-=-=-:', {event, topic})
    subscribeToEventSurvey(event, topic, callback, componentUuid);
  };

  const publishToServiceIdSurvey = (
    event: SocketTopics,
    topic: string,
    payload: IPublishRequest,
    subscribePath: string,
    serviceId: string,
    callback = () => {}
  ) => {

    console.log('=-=-=--=-=-asdasd', {payload, topic, event, subscribePath})
    publishToEventServiceIdSurvey(
      event,
      topic,
      payload,
      subscribePath,
      serviceId,
      callback
    );
  };

  return {
    client: socketClient,
    subscribeToSurvey,
    publishToServiceIdSurvey,
    subscribeToEvent,
    publishToEvent,
    unSubscribeToEvent,
    connect: socketConnect,
  };
};
